
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import * as Config from "../../constants/Config";
import tmdbApi from "../../api/tmdbApi";
import Tooltip from "@mui/material/Tooltip";

import { contentContext } from "../../context/contentContext";
import { keyActivate } from "../../utils/a11y";
let { lambda, country, appname } = window.app;

const Header = ({ fn }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
    const [data, setData] = useState("");
    const [userName, setUserName] = useState([]);



    // console.log("imageeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", image)

    const { userData, setUserData, businessData, setBusinessData, clientInfo, notifications, setNotifications, setClientInfo, setShowPopup, setSelectedOptions, setMultiSelectFields, uploadLogo, setActiveFieldsObj, setActiveMenuObj,
        setSelectedOptionsClientName, setSearchPayload, setInitialCategoriesData1, subscriberData, setSubscriberData, toggleMenu, setToggleMenu, GetTimeActivity, guardedNavigate } = useContext(contentContext)


    const notificationCount = notifications?.length || 0;
    const hasNotifications = notificationCount > 0;

    // console.log('notifffffffffffffffffff', notifications)

    const handleProfile = (e) => {
        guardedNavigate(() => {
            GetTimeActivity();
            navigate("/profile");
        })
    }
    const handleTransactions = (e) => {
        guardedNavigate(() => {
            // GetTimeActivity(); // Comment this out to test
            navigate("/mytransactions");
        })
    };
    // The Business Profile page is where the bank account lives, and the only
    // way in until now was the pencil beside the store name in the topbar -
    // easy to miss when what you're looking for is "where do I add my bank?".
    // The highlight flag tells that page to draw attention to the BANK ACCOUNT
    // panel once it loads.
    const handleBusinessProfile = () => {
        guardedNavigate(() => {
            GetTimeActivity();
            navigate("/businessprofile", { state: { highlight: "bank" } });
        })
    };
    const handleContactSupport = () => {
     guardedNavigate(() => {
            // GetTimeActivity(); // Comment this out to test
            navigate("/contactsupport");
        })
};

    const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
    const handleLogout = (e) => {

        guardedNavigate(() => {
            GetTimeActivity();
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            localStorage.removeItem("ClientName");
            localStorage.removeItem("ClientType");
            localStorage.removeItem("clientid");
            localStorage.clear()

            signoutsession();

            // // console.log('loginType',loginType);


            navigate("/signin");

            setUserData([])
            setActiveMenuObj({
                "Client Management": false,
                "Reports": false
            })
            setInitialCategoriesData1([])
            setSelectedOptions([])
            setMultiSelectFields({ dubbinglanguages: [], typeofrights: [], countryorigin: [], languages: [], genre: [], videoquality: [], certificate: [], subtitleslanguages: [], territoriesavailable: [], sport: [], musicgenre: [] })
            setActiveFieldsObj({ CookingshowActive: false, seriesActive: false, SportsActive: false, LiveEventActive: false, MusicActive: false })
            setSelectedOptionsClientName([])
            setSearchPayload({})
            setShowPopup(false)

        })

    }
    useEffect(() => {

        if (userData?.usertype === "STORE MANAGER" || userData?.usertype === "SECURITY") {


            setClientInfo(userData)
        }
    }, [userData]);  // Depending only on `loginType`

    // useEffect(() => {
    //     if ('serviceWorker' in navigator) {
    //         const messageHandler = (event) => {
    //             const message = event.data;
    //             if (message?.type === 'PUSH_RECEIVED') {
    //                 // console.log('notification coming...');
    //                 GetNotifications()
    //                 //notificationbyclient
    //                 // setCount(c=>c+1)
    //             }
    //         };

    //         navigator.serviceWorker.addEventListener('message', messageHandler);
    //         return () => {
    //             navigator.serviceWorker.removeEventListener('message', messageHandler);
    //         };
    //     }
    //     GetNotifications()
    // }, []);

    useEffect(() => {
        console.log('Notifications useEffect mounted');

        const messageHandler = (event) => {
            const message = event.data;
            console.log('Service worker message received:', message);
            if (message?.type === 'PUSH_RECEIVED') {
                console.log('Push notification received, fetching notifications...');
                getNotifications();

            }
        };

        if ('serviceWorker' in navigator) {
            console.log('Service worker is available, adding message listener');
            navigator.serviceWorker.addEventListener('message', messageHandler);
        } else {
            console.log('Service worker not available in navigator');
        }

        // Always fetch notifications on page load
        console.log('Fetching notifications on page load');
        getNotifications();

        // Cleanup
        return () => {
            console.log('Notifications useEffect cleanup');
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.removeEventListener('message', messageHandler);
            }
        };
    }, []);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    useEffect(() => {
        // userName = localStorage.getItem("ClientName")?.split(" ");

        setUserName(userData?.contactname?.split(" "));


        // console.log("userDtata----------------------->", userData)

    }, [userData]);

    const signoutsession = async () => {
        GetTimeActivity();
        try {
            //    const response = await tmdbApi.SignOutUser({ emailid: userData.email });


            // // console.log('loginType',loginType);
            let response;

            response = await tmdbApi.SignOutClient({ emailId: userData.emailId }, 'mmmmmmmmmm');


            // const response = await tmdbApi[loginType === 'admin' ? 'SignOutUser' : 'SignOutClient']({ emailid: userData.email });

            // // console.log("signout response",response);

        } catch {
            // console.log("error");
        }
    }


    const getNotifications = async () => {
        GetTimeActivity(); // Assuming this is necessary

        try {
            const response = await tmdbApi.getNotifications();

            // if (response?.result?.length > 0) {

            setNotifications(response?.result)
            // Make sure you're updating the context state properly

            // }
        } catch (error) {
            console.error("Error fetching client info:", error);
        }
    };


    // const scheduled = async () => {
    //     GetTimeActivity(); // Assuming this is necessary

    //     try {
    //         const response = await tmdbApi.getScheduled();


    //         getNotifications()
    //         // Make sure you're updating the context state properly


    //     } catch (error) {
    //         console.error("Error fetching client info:", error);
    //     }
    // };
    // // console.log("clientInfoooooooooooooooooooooooo",clientInfo)
    const handleEdit = () => {
        // setBusinessData(clientInfo)
        navigate("/businessprofile")
    }

    const handleRedirect = () => {
        GetTimeActivity();
        let userArr = userData.permissions

        // // console.log("userArr",userData)

        const obj = userArr.reduce((acc, item) => {
            if (item.submenus) acc[item.menu] = false;
            return acc;
        }, {});
        // // console.log('objjjjjjjj--->',obj)

        let k = userData

        let permissionList = userData && userData.permissions
        let filterdList = permissionList.filter((item) => item.display === true)
        let id = filterdList && filterdList[0] && filterdList[0].menu.split(" ").join("").toLowerCase()

        navigate("/" + id);
    }

    //   let userName=[]
    //   userName = localStorage.getItem("ClientName")?.split(" ");
    const handleUpgrade = () => {
        localStorage.setItem("backto", location.pathname)
        navigate("/upgradeplan")
    }
    const handleMenuToggle = () => {
        setToggleMenu(!toggleMenu)
    }


    const handleReadClick = (data) => {

        navigate("/readnotification/" + data?.notificationid)
        // readNotification
    }
    function formatTimeAgo(dateString) {
        const now = new Date();
        const created = new Date(dateString);
        const diffInSeconds = Math.floor((now - created) / 1000);

        if (diffInSeconds < 60) return 'Just now';
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    }



    return (
        <>

            <header id="page-topbar">
                <div className={`navbar-header`}>
                    <div className="d-flex">
                        <button type="button" className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                            id="vertical-menu-btn" onClick={handleMenuToggle}>
                            <i className="fa fa-fw fa-bars"></i>
                        </button>
                        <div className={`navbar-brand-box client-navbar-brand-box`}
                        >
                            <a
                                //  onClick={handleRedirect} 
                                className="logo">
                                <span className="logo-sm">
                                    <img src="./assets/img/brand/logo-sm.png" />
                                </span>
                                <span className="logo-lg">


                                    <img
                                        src={`${image}${appname}/images/web/logo-dark.png`}
                                        alt="Logo"
                                    />


                                </span>
                                <span className="Admin-badge">
                                    Pro
                                </span>

                            </a>
                        </div>





                        {/* <div className="position-relative">
                            <button onClick={e => subscribe(e)}>Subscribe</button>
                            </div> */}



                    </div>

                    <div className="d-flex profile_section">

                        <div className="dropdown d-lg-none ms-2">
                            <button type="button" className="btn header-item noti-icon waves-effect"
                                id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <i className="mdi mdi-magnify"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                                aria-labelledby="page-header-search-dropdown">

                                <form className="p-3">
                                    <div className="form-group m-0">
                                        <div className="input-group">
                                            <input type="text" className="form-control" placeholder="Search ..."
                                                aria-label="Recipient's username" />
                                            <div className="input-group-append">
                                                <button className="fill-btn-style" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* <div className="dropdown d-inline-block ms-3 d-flex align-items-center header-logo-section">
        <div className="header-logo-container me-3">
        <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/67c004ca91fc60a506fd97b9/fairfield_marriot_image_1740637386042.jpg" alt="Dario Bar Logo" className="rounded" width="40" height="40"/>
        <span className="material-symbols-outlined edit-icon">edit</span>
        </div>
        <div>
        <p className="menu-path mb-0">Welcome</p>
        <h4 className="card-title mb-0">Dario Bar and Lounge</h4>
        </div>
</div> */}
                        <div className="dropdown d-inline-block ms-3 d-flex align-items-center header-logo-section">
                            <div className="header-logo-container me-3">
                                <div id="logo-upload-container" className="no-logo-block">
                                    {clientInfo && clientInfo?.logo ? <img src={`${image}${clientInfo?.logo}`} alt="Dario Bar Logo" className="rounded" width="40" height="40" /> : <span className="material-symbols-outlined">storefront</span>}
                                    {/* <span className="material-symbols-outlined">storefront</span> */}

                                </div>
                            </div>

                            <div className="edit-wrapper me-2">
                                <p className="menu-path mb-0">Welcome</p>
                                <h4 className="card-title mb-0">{clientInfo?.businessname}</h4>
                            </div>
                            {/* <input 
      id="logo-upload" 
      accept="image/jpeg, image/png, image/heic, image/jpg" 
      className="d-none logo-input" 
    //   type="file"
    /> */}
                            {userData?.usertype === "BRAND MANAGER" &&
                                <label
                                    htmlFor="logo-upload"
                                    id="upload-logo-label"
                                    className="logo-label"
                                    onClick={handleEdit}
                                    onKeyDown={keyActivate(handleEdit)}
                                >
                                    <span className="material-symbols-outlined edit-icon" id="logo-edit-button">edit</span>
                                </label>}


                        </div>


                        <div className="dropdown d-flex align-items-center">
                            <div className="d-flex me-3">
                                <div className="d-flex align-items-center">

                                    <>
                                        {userData?.usertype === "BRAND MANAGER" && <div className="premium me-2">
                                            <div onClick={handleUpgrade} onKeyDown={keyActivate(handleUpgrade)} id="upgrade-button">
                                                <div className="upgrade-text">
                                                    UPGRADE
                                                </div>
                                                <span className="material-symbols-outlined f-5">
                                                    crown
                                                </span>
                                            </div>
                                        </div>}


                                        {/* <div className="dropdown notification-section">
                                            <button
                                                type="button"
                                                className="btn header-item noti-icon waves-effect"
                                                id="page-header-notifications-dropdown"
                                                data-bs-toggle={notifications && notifications?.length > 0 ? "dropdown" : ""}
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <i className="bx bx-bell bx-tada"></i>
                                                {notifications && notifications?.length > 0 && <span className="badge bg-danger rounded-pill">{notifications?.length}</span>}

                                            </button>
                                            {notifications && notifications?.length > 0 &&
                                                <div
                                                    className="dropdown-menu dropdown-menu-end p-3 notification-wrapper"
                                                    aria-labelledby="page-header-notifications-dropdown"
                                                    style={{ minWidth: "360px", maxWidth: "420px" }}
                                                >
                                                    <h4 className="dropdown-header fw-semibold">Notifications</h4>
                                                    {notifications?.map((item) => {
                                                        return (
                                                            <>
                                                                <div className="notification-item d-flex align-items-start mb-3" onClick={() => handleReadClick(item)}>
                                                                   
                                                                    <div className="flex-grow-1">
                                                                        <div className="right-section">
                                                                            <span className="fw-semibold">{item?.title}</span>

                                                                            <small className="text-muted">  {item?.notificationSent && formatTimeAgo(item?.notificationSent)}</small>
                                                                        </div>
                                                                        <div className="text-muted small mt-1 text-truncate-para">
                                                                            {item?.description}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="dropdown-divider"></div>
                                                            </>
                                                        )


                                                    })}




                                                </div>
                                            }

                                        </div> */}

                                        <Tooltip
                                            title={
                                                hasNotifications
                                                    ? `${notificationCount} Notification${notificationCount > 1 ? "s" : ""}`
                                                    : "No new notifications"
                                            }
                                            arrow
                                        >
                                            <div className="dropdown notification-section">
                                                <button
                                                    type="button"
                                                    className="btn header-item noti-icon waves-effect"
                                                    id="page-header-notifications-dropdown"
                                                    data-bs-toggle={hasNotifications ? "dropdown" : ""}
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    <i className={`bx bx-bell ${hasNotifications ? "bx-tada" : ""}`}></i>

                                                    {hasNotifications && (
                                                        <span className="badge bg-danger rounded-pill">
                                                            {notificationCount}
                                                        </span>
                                                    )}
                                                </button>

                                                {hasNotifications && (
                                                    <div
                                                        className="dropdown-menu dropdown-menu-end p-3 notification-wrapper"
                                                        aria-labelledby="page-header-notifications-dropdown"
                                                        style={{ minWidth: "360px", maxWidth: "420px" }}
                                                    >
                                                        <h4 className="dropdown-header fw-semibold">Notifications</h4>

                                                        {notifications.map((item, index) => (
                                                            <div key={index}>
                                                                <div
                                                                    className="notification-item d-flex align-items-start mb-3"
                                                                    onClick={() => handleReadClick(item)}
                                                                    onKeyDown={keyActivate(() => handleReadClick(item))}
                                                                >
                                                                    <div className="flex-grow-1">
                                                                        <div className="right-section">
                                                                            <span className="fw-semibold">{item?.title}</span>
                                                                            <small className="text-muted">
                                                                                {" "}
                                                                                {item?.notificationSent &&
                                                                                    formatTimeAgo(item?.notificationSent)}
                                                                            </small>
                                                                        </div>

                                                                        <div className="text-muted small mt-1 text-truncate-para">
                                                                            {item?.description}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="dropdown-divider"></div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </Tooltip>

                                    </>



                                    {/* <label className="form-label">Login: {localStorage.getItem("loginTime")}</label>    */}

                                </div>
                                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                                    aria-labelledby="page-header-notifications-dropdown">
                                    <div className="p-3">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h6 className="m-0" key="t-notifications"> Notifications </h6>
                                            </div>
                                            <div className="col-auto">
                                                <a href="#!" className="small" key="t-view-all"> View All</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div data-simplebar style={{ maxHeight: "230px" }}>
                                        <a href="" className="text-reset notification-item">
                                            <div className="d-flex">
                                                <div className="avatar-xs me-3">
                                                    <span className="avatar-title bg-primary rounded-circle font-size-16">
                                                        <i className="bx bx-cart"></i>
                                                    </span>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1" key="t-your-order">Your order is placed</h6>
                                                    <div className="font-size-12 text-muted">
                                                        <p className="mb-1" key="t-grammer">If several languages coalesce the
                                                            grammar</p>
                                                        <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                            key="t-min-ago">3 min ago</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="" className="text-reset notification-item">
                                            <div className="d-flex">
                                                <img src={image + Config.img + "avatar-3.jpg"}
                                                    className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1">James Lemire</h6>
                                                    <div className="font-size-12 text-muted">
                                                        <p className="mb-1" key="t-simplified">It will seem like simplified English.
                                                        </p>
                                                        <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                            key="t-hours-ago">1 hours ago</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="" className="text-reset notification-item">
                                            <div className="d-flex">
                                                <div className="avatar-xs me-3">
                                                    <span className="avatar-title bg-success rounded-circle font-size-16">
                                                        <i className="bx bx-badge-check"></i>
                                                    </span>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1" key="t-shipped">Your item is shipped</h6>
                                                    <div className="font-size-12 text-muted">
                                                        <p className="mb-1" key="t-grammer">If several languages coalesce the
                                                            grammar</p>
                                                        <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                            key="t-min-ago">3 min ago</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>

                                        <a
                                            href=""
                                            className="text-reset notification-item">
                                            <div className="d-flex">
                                                <img src={image + Config.img + "avatar-4.jpg"}
                                                    className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1">Salena Layfield</h6>
                                                    <div className="font-size-12 text-muted">
                                                        <p className="mb-1" key="t-occidental">As a skeptical Cambridge friend of
                                                            mine occidental.</p>
                                                        <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                            key="t-hours-ago">1 hours ago</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="p-2 border-top d-grid">
                                        <a className="btn btn-sm btn-link font-size-14 text-center" href="#">
                                            <i className="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">View
                                                More..</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <button type="button" className="btn header-item waves-effect" id="page-header-user-dropdown"
                                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {/* <img className="rounded-circle header-profile-user" src={image + Config.imgmiddle + "avatar-1.jpg"}
                                    alt="Header Avatar" /> */}



                                <span onClick={GetTimeActivity()} onKeyDown={keyActivate(GetTimeActivity())} className="user-badge">
                                    {userName?.length > 1
                                        ? (
                                            (userName[0]?.charAt(0) || "").toUpperCase() +
                                            (userName[1]?.charAt(0) || "").toUpperCase()
                                        )
                                        : (
                                            (userData?.contactname?.slice(0, 2) || "").toUpperCase()
                                        )
                                    }
                                </span>


                                <i className="mdi mdi-chevron-down d-none d-xl-inline-block" id="profile-inline-button"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">

                                <a className="dropdown-item" onClick={handleProfile} onKeyDown={keyActivate(handleProfile)} id="myprofile-button"><i className="bx bx-user font-size-16 align-middle me-1"></i>
                                    <span key="t-profile">Profile</span></a>
                                {/* Same gate as the pencil beside the store name above - business
                                    details and the bank account belong to the account owner, not to
                                    store managers or security users. */}
                                {userData?.usertype === "BRAND MANAGER" && <>
                                    <div className="dropdown-divider"></div>
                                    <a className="dropdown-item" onClick={handleBusinessProfile} onKeyDown={keyActivate(handleBusinessProfile)} id="mybusinessprofile-button">
                                        <i className="material-symbols-outlined font-size-16 align-middle me-1">storefront</i>
                                        <span>Business Profile</span>
                                    </a>
                                </>}
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item" onClick={handleTransactions} onKeyDown={keyActivate(handleTransactions)} id="mytransactions-button">
                                    <i className="material-symbols-outlined font-size-16 align-middle me-1">receipt_long</i>
                                    <span>My transactions</span>
                                </a>
<div className="dropdown-divider"></div>
<a className="dropdown-item" onClick={handleContactSupport} onKeyDown={keyActivate(handleContactSupport)} id="mycontactsupport-button">
    <i className="material-symbols-outlined font-size-16 align-middle me-1">support_agent</i>
    <span>Contact Support</span>
</a>
                                {/* <a className="dropdown-item" href="#"><i
                                    className="bx bx-wallet font-size-16 align-middle me-1"></i> <span key="t-my-wallet">My
                                        Wallet</span></a>
                                <a className="dropdown-item d-block" href="#"><span
                                    className="badge bg-success float-end">11</span><i
                                        className="bx bx-wrench font-size-16 align-middle me-1"></i> <span
                                            key="t-settings">Settings</span></a>
                                <a className="dropdown-item" href="#"><i
                                    className="bx bx-lock-open font-size-16 align-middle me-1"></i> <span
                                        key="t-lock-screen">Lock screen</span></a> */}
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item text-danger" style={{ position: "unset" }} onClick={handleLogout} onKeyDown={keyActivate(handleLogout)} id="mylogout-button"><i style={{ position: "unset" }}
                                    className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span
                                        key="t-logout">Logout</span></a>
                            </div>
                        </div>

                    </div >
                </div >
            </header >


        </>
    );
};

export default Header;
